import { useEffect } from "react";
import type { YouTubePlayer } from "youtube-player/dist/types";

import { VideoPlayMode } from "~/components/scmp-youtube-video/enums";

/**
 * For supporting play youtube video when clicking preview image
 */
export const useManualPlayEffect = (
  videoPlayMode: VideoPlayMode,
  player: OrUndefined<YouTubePlayer>,
) => {
  useEffect(() => {
    if (!player || videoPlayMode !== VideoPlayMode.Manual) return;
    const handleManualPlay = () => {
      void player.playVideo();
    };
    handleManualPlay();
  }, [videoPlayMode, player]);
};

export const useYoutubeExternalTracking = () => {};
